import React from 'react';

import css from '../../styles/table/tablerowskeleton.scss';

// @TODO: Merge with LoadingComponent.js

class TableRowSkeleton extends React.Component {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
            <tr>
                <td>
                    <div className={css.bounce}>
                        <div className={css.bounce1} />
                        <div className={css.bounce2} />
                    </div>
                </td>
                <td colSpan="4">&nbsp;</td>
            </tr>
        );
    }

}

export default TableRowSkeleton;



/** WEBPACK FOOTER **
 ** /src/shared/components/table/TableRowSkeleton.js
 **/